export const MODE_DETAIL = {
  CREATE: "create",
  UPDATE: "update",
  VIEW: "view",
};
